import {request} from '@/network/request'

//资源库图片
export function getGlobalInfo(query) {
    return request({
        url: '/gaoligong/picturevideo/getGlobalInfo',
        method: 'get',
        params: query,
    })
}
